export default __webpack_public_path__ + "static/media/1440x300fURNITURE Desktop.61dbf734.jpg";